// extracted by mini-css-extract-plugin
export default {"textIcon":"ActivityType__textIcon___CPskM"};